export const
    GET_CAPTCHA_SITE_KEY_FAILURE= "GET_CAPTCHA_SITE_KEY_FAILURE",
    GET_CAPTCHA_SITE_KEY_REQUEST= "GET_CAPTCHA_SITE_KEY_REQUEST",
    GET_CAPTCHA_SITE_KEY_SUCCESS= "GET_CAPTCHA_SITE_KEY_SUCCESS",
    VALIDATE_CAPTCHA_RESULT_FAILURE = "VALIDATE_CAPTCHA_RESULT_FAILURE",
    VALIDATE_CAPTCHA_RESULT_REQUEST = "VALIDATE_CAPTCHA_RESULT_REQUEST",
    VALIDATE_CAPTCHA_RESULT_SUCCESS = "VALIDATE_CAPTCHA_RESULT_SUCCESS";
    


// WEBPACK FOOTER //
// ./src/types/Captcha.js